import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useStore } from "@/lib/store";
import { toast } from "sonner";

export default function Auth() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [mode, setMode] = useState(params.get("mode") === "register" ? "register" : "login");
  const { login, register } = useStore();
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === "login") await login(f.email, f.password);
      else await register(f.name, f.email, f.password);
      nav("/account");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Authentication failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-16" data-testid="auth-page">
      <div className="w-full max-w-md bg-[#1C130E] border border-[#D4AF37]/20 p-8 sm:p-10 gold-glow">
        <div className="eyebrow text-center">The Boutique</div>
        <h1 className="font-serif-luxe text-3xl text-[#FAF8F5] text-center mt-2">{mode === "login" ? "Welcome Back" : "Join Laxmi Aura"}</h1>
        <p className="text-center text-xs text-[#C2B29F] mt-3">
          {mode === "login" ? "Sign in to your personal atelier." : "Create your account for a bespoke experience."}
        </p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          {mode === "register" && (
            <label className="block">
              <span className="text-[11px] tracking-[0.14em] uppercase text-[#C2B29F]">Full name</span>
              <input data-testid="auth-name" required value={f.name} onChange={(e) => setF({...f, name: e.target.value})} className="mt-2 w-full bg-transparent border border-[#D4AF37]/25 px-3 py-2.5 text-sm text-[#FAF8F5] focus:border-[#D4AF37] focus:outline-none"/>
            </label>
          )}
          <label className="block">
            <span className="text-[11px] tracking-[0.14em] uppercase text-[#C2B29F]">Email</span>
            <input data-testid="auth-email" type="email" required value={f.email} onChange={(e) => setF({...f, email: e.target.value})} className="mt-2 w-full bg-transparent border border-[#D4AF37]/25 px-3 py-2.5 text-sm text-[#FAF8F5] focus:border-[#D4AF37] focus:outline-none"/>
          </label>
          <label className="block">
            <span className="text-[11px] tracking-[0.14em] uppercase text-[#C2B29F]">Password</span>
            <input data-testid="auth-password" type="password" required value={f.password} onChange={(e) => setF({...f, password: e.target.value})} className="mt-2 w-full bg-transparent border border-[#D4AF37]/25 px-3 py-2.5 text-sm text-[#FAF8F5] focus:border-[#D4AF37] focus:outline-none"/>
          </label>
          <button data-testid="auth-submit" disabled={loading} className="btn-gold w-full mt-6">{loading ? "…" : (mode === "login" ? "Sign In" : "Create Account")}</button>
        </form>

        <div className="mt-6 text-center text-xs text-[#C2B29F]">
          {mode === "login" ? (
            <>New to Laxmi Aura? <button onClick={() => setMode("register")} className="text-[#D4AF37] gold-underline">Create an account</button></>
          ) : (
            <>Already have an account? <button onClick={() => setMode("login")} className="text-[#D4AF37] gold-underline">Sign in</button></>
          )}
        </div>

        <div className="mt-6 pt-6 border-t border-[#D4AF37]/15 text-center">
          <div className="text-[10px] tracking-[0.24em] uppercase text-[#C2B29F] mb-2">Demo Access</div>
          <div className="text-xs text-[#FAF8F5]">Admin: admin@laxmiaura.com / admin123</div>
          <div className="text-xs text-[#FAF8F5]">Guest: demo@laxmiaura.com / demo1234</div>
        </div>
      </div>
    </div>
  );
}
